<template>
  <div class="companies-container">
    <a style="float: right" @click="closePool">
      收回展开
      <a-icon type="up" />
    </a>
    <div v-for="(item, index) in unfoldList" :key="index">
      <div class="content-item">
        <header>{{ +item[0].type === 1 ? '我参与的项目' : moment(item[0].createAt).format('YYYY年M月') }}({{ item.length }})</header>
        <div style="display: flex; flex-wrap: wrap">
          <!-- @click="toProjectDetail(task.projectId)" -->
          <div v-for="task in item" :key="task.id" style="margin: 0 5% 30px 0; width: 20%" class="company-card">
            <div class="task done task-card ui-sortable-handle" id="project-item" @click="toProjectDetail(task.id)">
              <div :class="['task-content-set', 'open-detail', { portfolio: task.oldMark === 2 }]">
                <div class="task-content-wrapper">
                  <div class="task-top" style="align-items: center; margin-bottom: 0">
                    <div class="task-top-left" style="min-height: 60px; min-width: 60px; margin-right: 20px">
                      <img v-if="task.logoPath" :src="task.logoPath" class="avatar img-48 hinted" style="min-height: 60px; min-width: 60px" />
                    </div>
                    <div class="task-top-right">
                      <div class="company_info">
                        <div class="task-content label" style="width: 146px" v-if="task">{{ task.name }}</div>
                        <div class="sector" v-if="task.sector">{{ task.sector.name }}</div>
                      </div>
                      <div class="card-user">
                        <div>
                          <span>
                            <span v-for="(user, ui) in task.dealLeaders" :key="ui">
                              {{ user.nickname }}
                              <span v-if="ui != task.dealLeaders.length - 1">、</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="task.secret === 2" class="secret-label secret">绝密</div>
                  <div v-if="task.secret === 3" class="secret-label patent">专利</div>
                  <div v-if="task.ifProtect" class="secret-label protect">延保</div>
                </div>
              </div>
            </div>
            <div class="company-desc" :class="{ 'half-height': true }">
              <div class="company-desc-pool">
                <div class="desc-content">{{ task.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a-divider style="background-color: #dedede; margin-top: 0" v-if="index !== unfoldList.length - 1"></a-divider>
    </div>
    <div v-if="total > allLength" style="width: 300px; margin: auto">
      <a-divider style="color: #1890f7">
        <div @click="getMore" style="cursor: pointer">
          加载更多
          <a-icon type="down" />
        </div>
      </a-divider>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Event from '@/utils/event';
import moment from 'moment';
import { getCompanyListByState, ifCanAccess } from '../../api/project';
export default {
  name: 'unfoldCompanies',
  props: {
    stateName: {
      type: String,
      default: ''
    },
    stateId: {
      type: Number,
      default: 0
    },
    tagIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    searchName: {
      type: String,
      default: ''
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    sectorId: {
      type: [String, Number],
      default: 0
    },
    searchUserId: {
      type: [String, Number],
      default: 0
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    onlyCreateTime: {
      type: String,
      default: ''
    },
    checkedPosOption: {
      type: Array,
      defauly: []
    },
    posList: {
      type: Array,
      defauly: []
    },
    financingStage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      unfoldList: [],
      myJoin: [],
      page: 1,
      pageSize: 30,
      total: 0,
      moment
    };
  },
  watch: {
    body() {
      if (+this.stateId === 0) {
        return;
      }
      this.myJoin = [];
      this.unfoldList = [];
      this.getUnfoldList();
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    body() {
      return {
        tagIds: this.tagIds,
        searchName: this.searchName,
        userId: this.searchUserId,
        sectorId: this.sectorId,
        userCompanyUserIds: this.userId,
        startTime: this.startTime,
        endTime: this.endTime,
        onlyCreateTime: this.onlyCreateTime,
        checkedPosOption: this.checkedPosOption,
        posList: this.posList,
        financingStage: this.financingStage
      };
    },
    allLength() {
      let len = 0;
      this.unfoldList.forEach(item => {
        len += item.length;
      });
      return len;
    }
  },
  created() {},
  methods: {
    toProjectDetail(id) {
      ifCanAccess({ id }).then(res => {
        if (res.code === 200 && res.data) {
          window.open(`${this.$route.path}/detail?id=${id}`);
        } else if (res.code === 200) {
          window.open(`${this.$route.path}/detail?id=${id}&noPermission=true`);
          // this.$message.error('无访问权限');
        }
      });
    },
    closePool() {
      Event.$emit('closePoolEvent');
    },
    getMore() {
      this.page++;
      this.getUnfoldList();
    },
    async getUnfoldList() {
      let body = {
        stateId: this.stateId,
        tagIds: this.tagIds,
        searchName: this.searchName,
        sectorId: this.sectorId,
        userCompanyUserIds: this.userId,
        startTime: this.startTime,
        endTime: this.endTime,
        onlyCreateTime: this.onlyCreateTime,
        page: this.page,
        pageSize: this.pageSize,
        locationType: this.checkedPosOption.join(','),
        locationName: this.posList.map(item => item.key).join(','),
        queryType: 2,
        financingStage: this.financingStage
      };
      const res = await getCompanyListByState(body);
      if (res.code === 200) {
        this.total = res.data.total;
        //我参与的
        let list = res.data.list;
        list.forEach(item => (item.type = item.users.some(_ => _.id === this.userInfo.id) ? 1 : 0));
        let myJoin = list.filter(item => +item.type === 1);
        let currentOther = list.filter(item => +item.type === 0);
        let outIndex = 0;
        if (myJoin.length) {
          outIndex = 1;
          this.myJoin = this.myJoin.concat(myJoin);
          this.$set(this.unfoldList, 0, this.myJoin);
        }
        if (!currentOther.length) {
          return;
        }
        if (!this.unfoldList[outIndex]) {
          this.$set(this.unfoldList, outIndex, []);
        } else {
          if (moment(this.unfoldList[this.unfoldList.length - 1][0].createAt).format('YYYY年MM月') === moment(currentOther[0].createAt).format('YYYY年MM月')) {
            outIndex = this.unfoldList.length - 1;
          } else {
            outIndex = this.unfoldList.length;
            this.$set(this.unfoldList, outIndex, []);
          }
        }
        currentOther.forEach((item, index) => {
          this.unfoldList[outIndex].push(item);
          if (index !== currentOther.length - 1) {
            if (moment(currentOther[index + 1].createAt).format('YYYY年MM月') !== moment(item.createAt).format('YYYY年MM月')) {
              outIndex++;
              this.$set(this.unfoldList, outIndex, []);
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getUnfoldList();
  }
};
</script>

<style lang="less">
@import url('./task.less');
.companies-container {
  background: #f1f1f1;
  height: 75vh;
  padding: 20px 30px;
  overflow: auto;
}
.content-item {
  header {
    margin-bottom: 20px;
    color: #040404;
    font-size: 15px;
  }
}
.card-user {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 12px;
}

.company-desc.half-height {
  height: 38px;
}
.company-desc {
  height: 76px;
  width: 100%;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  .company-desc-pool {
    width: 100%;
    background-color: #f1f1f1;
    position: absolute;
    z-index: 10;
    div {
      width: 100%;
      word-wrap: break-word;
      word-break: normal;
    }
  }
}
.company-card:hover .open-detail {
  // box-shadow: 10px 15px 5px #dedede;
  border: 2px solid #ababab;
  border-bottom: 0;
}
.company-card:hover .desc-content {
  padding: 0 10px;
}

.desc-content {
  // padding: 0 10px;
  &:first-child {
    margin-top: 4px;
  }
  margin-bottom: 18px;
  line-height: 18px;
}

.company-card:hover .company-desc {
  overflow: visible;
  z-index: 100;
  .company-desc-pool {
    // box-shadow: 10px 10px 5px #dedede;
    border: 2px solid #ababab;
    border-top: 0;
  }
}
</style>
